class Animation {
	constructor() {
		this.items = document.querySelectorAll('[data-animation]');
		setTimeout(() => {
			document.addEventListener('scroll', this.test.bind(this));
			document.addEventListener('resize', this.test.bind(this));
			this.test();
		}, .5e3);
	}
	
	test() {
		for(let i = 0 ; i<this.items.length ; i++) {
			let item  = this.items[i];
			let rect = item.getBoundingClientRect();
			item.setAttribute (
				'data-in-viewport',
				rect.top < document.body.clientHeight || rect.top < 0
			);
		}
	}
}

window.addEventListener('load', () => {
	new Animation();
});